import * as React from "react"
import T from "../T/T";
import { Link } from "gatsby";
import { LocaleLink } from "../../lib/IntlTools";
import "./styles.scss";

export default function DwaHero({ showReward, showTitle, customClassname, imgLink, imgHeight, text }) {

    return <div className={`design-slider ${customClassname}`}>
        <div className="slide">
            {!!showTitle && (
                <div className="concealed-text">
                    <div
                        className="concealed-text-container">
                        <h3><T>{text}</T></h3>
                    </div>
                    {!!showReward && (<div className="claim-rewards-button">
                        <Link to={LocaleLink("/form")}>
                            <T>claim-button</T>
                        </Link>
                    </div>
                    )}
                </div>
            )}
            <div className="image-bg">
                <img src={`/static/images/dwa/${imgLink}`} alt="" style={{ height: imgHeight }} />
            </div>
        </div>
    </div>
}
